import styled from "@emotion/styled";
import { ThemeKey } from "@smartsheet/design-tokens";
import { datePickerTheme } from "./datePickerTheme";

interface DatePickerDayContainerProps {
    themeMode: ThemeKey;
}

export const DatePickerDayContainer = styled("div")<DatePickerDayContainerProps>`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    row-gap: ${({ themeMode }) => datePickerTheme.dayRowGap(themeMode)};
    margin-top: ${({ themeMode }) => datePickerTheme.dayContainerMarginTop(themeMode)};
`;
